import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { FilterProjectDto } from 'src/app/web/interfaces/project/list/filterProjectDto';
import { FilterProjectInfoDto } from 'src/app/web/interfaces/project/list/filterProjectInfoDto';
import { FilterProjectInfoFrenteDto } from 'src/app/web/interfaces/project/list/filterProjectInfoFrenteDto';
import { FilterProjectInfoItemDto } from 'src/app/web/interfaces/project/list/filterProjectInfoItemDto';
import { FilterProjectStadoDto } from 'src/app/web/interfaces/project/list/filterProjectStadoDto';
import { ViewProject } from 'src/app/web/interfaces/project/list/viewProjectDto';
import { DropdownSettingsStado, FormatDataTableGlobal } from 'src/app/web/util/formatDataTable';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ApiServiceERP } from '../../../apis/ApiServiceERP';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { ErrorService } from 'src/app/shared/services/errors.service';

export class listClient {

  id: number;
  name: string;
  listFrente: { 
    name: string;
    id: number;
  };
  listHeadquarter: {};
  

}




@Component({
  selector: 'app-list-client',
  templateUrl: './frente-client.component.html',
  styleUrls: ['./frente-client.component.scss']
})
export class FrenteClientComponent implements AfterViewInit, OnDestroy, OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  dtOptions: DataTables.Settings = {};

  

  searchForm: FormGroup;
  paymentsform: FormGroup;
  listViewProjectDto: ViewProject[] = []
  listViewProjectDtoBack: ViewProject[] = []
  filterProjectInfoDto: FilterProjectInfoDto = {} as FilterProjectInfoDto
  filterProjectInfoFrenteDto: FilterProjectInfoFrenteDto[] = []
  filterProjectDto: FilterProjectDto = {} as FilterProjectDto;
  ListClient: listClient= {} as listClient;
 
  ListClient2 = []
  selectedItems = [];

  ListFrente = [];
  dropdownSettings = {};
  opcionClient = 0
  opcionFrete = 0
  id;
  opcionSeleccionado = "todo"
  items!: FormArray;
  idSubscription: Subscription;


  constructor(private http: HttpClient,
    private spinner: NgxSpinnerService,
    config: NgbDropdownConfig,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiServiceERP,
    private fb: FormBuilder,
    private errorService:ErrorService,
    private router:Router
    ) {
    config.placement = 'bottom';
    this.idSubscription = this.activatedRoute.params.subscribe(params => {
      this.id = params['id'];


    })
  }

  ngOnInit(): void {


    this.dtOptions = FormatDataTableGlobal();


    this.spinner.show();

    this.apiService.getService('client-list').subscribe({
      next: (rs: any) => {
        // console.log(rs.listProjectPlay);

        if (rs.code == null) {
          // si la respuesta no tiene error pero no tiene data se manda un mensaje de error y se retorna al home
          if (rs == '' || rs == null) {
            this.spinner.hide();
            Swal.fire({
              title: 'No se encontraron registros',
              text: '',
              icon: 'info',
              confirmButtonText: 'Aceptar',
              heightAuto: false
            }).then((res) => {
              if (res.isConfirmed || res.isDismissed) {

              }
            });
          }

          this.ListClient = rs;


          rs.map((frente) => {
            
            if (this.id == frente.id) {

              this.ListFrente = frente.listFrente;
            }

          })




          this.spinner.hide();
          this.rerender();
        } else {

          this.spinner.hide();
          Swal.fire({
            title:  rs.error,
            text: '',
            icon: 'error',
            heightAuto: false
            });
        }
      },
      error: (error) => {
        this.errorService.error(error);
      },
    });

  }

  get form() {
    return this.searchForm.controls;
  }

  onItemSelect(item: any) {
    //console.log(item);
  }

  actionSelectClient() {
    this.filterProjectInfoFrenteDto = this.form['client'].value.listFrente;

  }

  nuevoCampo() {
    this.items = this.paymentsform.get("items") as FormArray
    let info = this.fb.group({
      hes: "",
      facture: "",
      facture_date: ""
    });

    this.items.push(info)

  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  stageDeleteFrente(id:any){
    Swal.fire({
              title: 'Eliminar',
              text: '¿Desea eliminar el frente?',
              icon: 'error',
              showCancelButton:true,
              confirmButtonText: 'Aceptar',
              cancelButtonText:"No, cancelar",
              heightAuto: false
            }).then((res) => {
              if (res.isConfirmed) {
                this.spinner.show()
                this.apiService.deleteService('client-frente-delete?id=' + id).subscribe({
                  next: (rs: any) => {
                    if (rs) {
                      this.spinner.hide();
                      Swal.fire({title:'Exito!',text: 'Se ha eliminado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
                      
                    } else {
                        this.spinner.hide();
                        Swal.fire({
                          title:  rs.error,
                          text: '',
                          icon: 'error',
                          heightAuto: false
                          }); } },
                  error: (error) => {
                    this.errorService.error(error);
                  },});
              }
              else if ( res.dismiss === Swal.DismissReason.cancel){
                Swal.fire({
                  title: 'Cancelado',
                  text: 'Operación cancelada.',
                  icon: 'error',
                  heightAuto: false
                  })

              }
            });


    
  }



  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

}
